import type {
  StorefrontBuyerCurrency,
  StorefrontCatalogProductPayloadV1,
} from '@stokmerter/contracts';

export type CatalogImage = {
  url: string;
  role: 'lifestyle' | 'flat' | 'colors';
};

export type CatalogProduct = {
  recordId: string;
  recordVersion: number;
  payload: StorefrontCatalogProductPayloadV1;
  images: CatalogImage[];
};

export type CatalogViewType = 'lifestyle' | 'flat';

export function lifestyleImages(product: CatalogProduct): string[] {
  return product.images.filter((image) => image.role === 'lifestyle').map((image) => image.url);
}

export function flatImage(product: CatalogProduct): string | null {
  return product.images.find((image) => image.role === 'flat')?.url ?? null;
}

export function colorsImage(product: CatalogProduct): string | null {
  return product.images.find((image) => image.role === 'colors')?.url ?? null;
}

export function primaryImage(product: CatalogProduct, viewType: CatalogViewType): string | null {
  const lifestyle = lifestyleImages(product);
  return (viewType === 'flat' ? flatImage(product) : lifestyle[0]) ??
    lifestyle[0] ?? flatImage(product) ?? colorsImage(product) ?? product.images[0]?.url ?? null;
}

export function priceMinor(product: CatalogProduct, currency: StorefrontBuyerCurrency): number | null {
  return currency === 'TRY' ? product.payload.priceTlMinor : product.payload.priceUsdMinor;
}

export function formatBuyerPrice(value: number | null, currency: StorefrontBuyerCurrency): string {
  if (value === null) return 'Fiyat bilgisi yok';
  return new Intl.NumberFormat(currency === 'TRY' ? 'tr-TR' : 'en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value / 100);
}
